import { createStore } from 'redux'

import Header from './Header/index'

export default createStore(Header)
